import { createSelector } from 'reselect';
const getTeams = (state) => state.boxscore.teams;
const getLanguage = (state) => state?.config?.language;

const getGameState = (state) => {
    const {
        gumbo: {
            gameData: {
                status: {
                    abstractGameState
                } = {}
            } = {}
        } = {}
    } = state;

    return abstractGameState;
};

export const getBoxscoreTeamsState = createSelector(
    [getTeams, getLanguage, getGameState],
    (teams, language, abstractGameState) => ({
        teams,
        language,
        abstractGameState
    })
);
